import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  makeStyles, Typography
} from '@material-ui/core';
import CardHeader from '@material-ui/core/CardHeader';
import LinearProgress from '@material-ui/core/LinearProgress';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { history } from 'src/utils/utils';
// import SettingsView from "../../rfp/RfpDashboardView/index";
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex',
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  para: {
    left: "36%",
    color: "#546e7a !important",
    marginTop: "10px",
    position: "absolute",
  },
  responsePara: {
    left: "33%",
    color: "#546e7a !important",
    marginTop: "10px",
    position: "absolute",
  },
  LiveRfp: {
    left: "41%",
    color: "#546e7a !important",
    marginTop: "10px",
    position: "absolute",
  },
  CardHeader: {
    background: '#4688f0',
    color: '#ffffff',
  },
  buttonProgress: {
    position: "relative",
    left: "-20%",
    top: "8px",
    marginTop: "10px",
    width: "392px",
    backgroundColor: "lightGreen",
    '@global': {
      '.MuiLinearProgress-barColorPrimary': {
        backgroundColor: "#38c75f",
      },
    },


  },

  buttonProgressBar: {
    position: "relative",
    left: "-3%",
    top: "8px",
    width: "348px",
    marginTop: "10px",
    backgroundColor: "#cbeffb",
    '@global': {
      '.MuiLinearProgress-barColorPrimary': {
        backgroundColor: "#82d7f7",
      },
    },
  },

  boxContainer: {
    padding: "16px 16px 0px 16px",
  },

  active: {
    position: "absolute",
    right: "-194%",
    top: "24%",
    borderRadius: "50%",
    bottom: "9px",
    backgroundColor: "#52b152",
    height: "10px",
    width: "10px"
  }


}));

const ProductCard = ({ className, product, ...rest }) => {
  const classes = useStyles();
  // console.log(product, "product");
  const handleEdit = (product) => {
    localStorage.setItem('rfpId', product._id);
    if (product.isInvited) {
      history.push('/app/submit-rfp' + '/' + product._id);
    } else if (product.rfpPublished) {
      history.push('/app/edit-rfp' + '/' + product._id);
    } else {
      history.push('/app/update-rfp' + '/' + product._id);
    }
  }

  const handleDashBoard = (product) => {
    if (product.isInvited && !product.isSubmitted && product.invitedRfpStepper && product.invitedRfpStepper.isRfpAccepted === "2") {
      return
    }
    localStorage.setItem('rfpId', product._id);
    // history.push('/app/dashboard-rfp' + '/' + product._id);
    if (product.isInvited) {
      history.push('/app/submit-rfp' + '/' + product._id + '?product_name=' + product.rfpName);
    } else if (product.rfpPublished) {
      history.push('/app/dashboard-rfp' + '/' + product._id + '?product_name=' + product.rfpName);
    } else {
      history.push('/app/update-rfp' + '/' + product._id + '?product_name=' + product.rfpName);
    }
  }
  return (
    <>
      <Card
        /*  className={clsx(classes.root, className)}
         {...rest} */
        onClick={() => handleDashBoard(product)}
        className={'requestly-card'}
        style={{ width: "320px", maxWidth: "100%", marginLeft: "20px", marginTop: "20px", cursor: "pointer" }}
      >
        <CardContent>
          <CardHeader
            className={classes.CardHeader}
            title="RFP"
          />
          <Box
            display="flex"
            justifyContent="center"
            mb={3}
          >
            {/*  <Avatar
            alt="Product"
            src={product.media}
            variant="square"
          /> */}
          </Box>
          <Typography
            align="center"
            color="textPrimary"
            gutterBottom
            variant="h4"
            className="requestly-card-text"
          >
            {product.rfpName}
          </Typography>
          <p
            className="requestly-card-date"
          >
            {moment(product.createdAt).format('DD MMM YYYY')}
          </p>
        </CardContent>
        <Box flexGrow={1} />
        <Divider />
        <Box p={2} className={classes.boxContainer}>
          <Grid
            container
            justify="space-between"
            spacing={2}
            style={{ position: "relative" }}
          >
            <Grid
              className={classes.statsItem}
              item
            >
              <Typography
                color="textSecondary"
                display="inline"
                variant="body2"
                className={(product.submittedVendorIds && product.submittedVendorIds.length === 0 && product.rfpPublished && !product.isInvited) ? classes.LiveRfp : product.isSubmitted ? classes.responsePara : classes.para}
              >
                {product.isInvited ?
                  (product.isSubmitted && product.invitedRfpStepper && product.invitedRfpStepper.isRfpAccepted === "1") ? 'Response Submitted'
                    : !product.isSubmitted && product.invitedRfpStepper && product.invitedRfpStepper.isRfpAccepted === "2" ? <span style={{ marginLeft: "10px", color: "red" }}>Declined</span> : 'Submit Response'
                  :
                  (product.rfpPublished && product.rfpCompletionPercent === 100)
                    ? 'RFP Completed' : (product.rfpPublished) ? 'Live RFP' : 'Update RFP'
                }
                <div className={product.rfpPublished && product.rfpCompletionPercent < 100 && classes.active}></div>

              </Typography>
            </Grid>
            <Grid>
              <LinearProgress variant="determinate" className={product.isInvited ?
                product.isSubmitted ?
                  classes.buttonProgressBar : classes.buttonProgressBar
                :
                product.rfpPublished ?
                  classes.buttonProgress : classes.buttonProgressBar
              } value={product.isInvited ? product.completedPer === undefined ? product.completedPer === 0 : product.completedPer : product.rfpCompletionPercent === undefined ? product.rfpCompletionPercent === 0 : product.rfpCompletionPercent} />
            </Grid>
            <Grid
              className={classes.statsItem}
              item
            >
            </Grid>
          </Grid>
        </Box>
      </Card>
    </>
  );
};

ProductCard.propTypes = {
  className: PropTypes.string,
  product: PropTypes.object.isRequired
};

export default ProductCard;
